export enum LinkId {
  APPOINTMENT_TIME = 'Appointment Time',
  APPOINTMENT_TIME_LOAD_MORE = 'Appointment Time Load more',

  BOOKING_CONTINUE_BUTTON = 'Booking Continue Button',

  COVID_BOOK_REDIRECT_AVAILABLE = 'Covid Vaccine Booking Redirect - Covid Booking Form',
  COVID_BOOK_REDIRECT_NOT_AVAILABLE = 'Covid Vaccine Booking Redirect - Not Available at practice',
  COVID_BOOK_REDIRECT_NO_APPOINTMENTS = 'Covid Vaccine Booking Redirect - No Appointments',
  COVID_BOOK_REDIRECT_NOT_AVAILABLE_NEW_PATIENT = 'Covid Vaccine Booking Redirect - Not Available at for New Patients',
  COVID_BOOK_REDIRECT_NOT_AVAILABLE_EXISTING_PATIENT = 'Covid Vaccine Booking Redirect - Not Available at for Existing Patients',
  FLU_BOOK_REDIRECT_AVAILABLE = 'Flu Vaccine Booking Redirect - Flu Booking Form',
  FLU_BOOK_REDIRECT_NOT_AVAILABLE = 'Flu Vaccine Booking Redirect - Not Available at practice',
  FLU_BOOK_REDIRECT_NO_APPOINTMENTS = 'Flu Vaccine Booking Redirect - No Appointments',
  FLU_BOOK_REDIRECT_NOT_AVAILABLE_NEW_PATIENT = 'Flu Vaccine Booking Redirect - Not Available at for New Patients',
  FLU_BOOK_REDIRECT_NOT_AVAILABLE_EXISTING_PATIENT = 'Flu Vaccine Booking Redirect - Not Available at for Existing Patients',
  COVID_CHECK_ELIGIBILITY_BUTTON = 'Covid-19 Vaccine Check eligibility button',
  COVID_CHECK_ELIGIBILITY_LINK = 'Covid-19 Vaccine Checked your eligibility link',
  COVID_ELIGIBLE_BUTTON = 'Covid-19 Vaccine I am eligible button',

  END_OF_RESULTS_RESET_FILTER = 'End of results suggestion - Reset filters',

  FILTER_BY_ACCEPTS_NEW_PATIENTS_BUTTON = 'Filter by accepts new patients button',
  FILTER_BY_BULK_BILLING_BUTTON = 'Filter by bulk billing button',
  FILTER_BY_CONSULTATION_TYPE_BUTTON = 'Filter by consultation type button',
  FILTER_BY_VACCINE_TYPE_BUTTON = 'Filter by vaccine type button',
  FILTER_BY_DATE_BUTTON = 'Filter by date button',
  FILTER_BY_GENDER_BUTTON = 'Filter by gender button',
  FILTER_BY_GOVERNMENT_SCHEME_BUTTON = 'Filter by government scheme button',
  FILTER_BY_HICAPS_BUTTON = 'Filter by HICAPS button',
  FILTER_BY_INSURANCE_BUTTON = 'Filter by insurance button',
  FILTER_BY_LANGUAGE_APPOINTMENTS_BUTTON = 'Filter by language button',
  FILTER_BY_LOCATION_BUTTON = 'Filter by location button',
  FILTER_BY_ONLINE_APPOINTMENTS_BUTTON = 'Filter by online appointments button',
  FILTER_BY_PAYMENT_METHOD_BUTTON = 'Filter by payment method button',
  FILTER_BY_PRICING_AVAILABLE_BUTTON = 'Filter by pricing available button',
  FILTER_BY_SPECIAL_OFFER_BUTTON = 'Filter by special offer button',
  FILTER_BY_SPECIALTY_BUTTON = 'Filter by specialty button',
  FILTER_BY_TELEHEALTH_BUTTON = 'Filter by telehealth button',
  FILTER_BY_TIME_BUTTON = 'Filter by time button',
  FILTER_BY_MORE_FILTERS = 'Filter by more filters button',
  FILTER_OPTION_LANGUAGES_SPOKEN = 'Filter option selected: Languages spoken',
  FILTER_OPTION_PAYMENT_METHOD = 'Filter option selected: Payment method',
  FILTER_OPTION_GOVT_SCHEMES = 'Filter option selected: Govt Schemes',
  FOOTER = 'Footer Links',
  FOOTER_PRACTICE_DISCOVER_MORE = 'Footer Practice Discover More button',
  FOOTER_PRACTICE_LOGIN = 'Footer Practice Login button',

  HEADER_ARE_YOU_A_PRACTICE = 'Header Are you a practice',
  HEADER_CHANGE_MY_PASSWORD = 'Header Change my password link',
  HEADER_CORPORATE_GROUP_IDENTITY_LOG_IN = 'Header Corporate Group Identity Log In button',
  HEADER_CORPORATE_GROUP_IDENTITY_LOG_OUT = 'Header Corporate Group Identity Log Out',
  HEADER_HE_LOGO = 'Header HE logo',
  HEADER_HELP = 'Header Help',
  HEADER_LOG_IN_BUTTON = 'Header Log in button',
  HEADER_LOG_OUT = 'Header Log Out',
  HEADER_LOGGED_IN_BOOKING = 'Header Logged In Booking Link',
  HEADER_LOGGED_IN_FAVOURITES = 'Header Logged In Favourites Link',
  HEADER_LOGGED_IN_HEALTH_INTERESTS = 'Header Logged in Health Interests',
  HEADER_LOGGED_IN_OFFERS = 'Header Logged in Offers',
  HEADER_LOGGED_IN_PRIVACY = 'Header Logged in Data & Privacy Link',
  HEADER_LOGGED_IN_PROFILES = 'Header Logged in Profiles Link',
  HEADER_LOGIN_SIGN_UP = 'Header Login/Sign-up button',
  HEADER_PATIENT_ACCOUNT_USER_ICON = 'Header Patient Account User Icon',
  HEADER_SEARCH_BAR = 'Header Search bar',

  LOAD_MORE_RESULTS_BUTTON = 'Load more results button',

  MOBILE_HAMBURGER_BUTTON = 'Mobile Hamburger Menu Button',
  MOBILE_LOGIN_SIGNUP = 'Mobile Menu Log In or Sign up link',
  MOBILE_MENU_ACCOUNT = 'Mobile Menu Logged In Account link',
  MOBILE_MENU_ARE_YOU_A_PRACTICE = 'Mobile Menu Are you a practice link',
  MOBILE_MENU_BLOG = 'Mobile Menu Blog Link',
  MOBILE_MENU_BOOKINGS = 'Mobile Menu Logged In Bookings link',
  MOBILE_MENU_DOWNLOAD_APP = 'Mobile Menu Download the app link',
  MOBILE_MENU_FIND_A_PROVIDER = 'Mobile Menu Find a provider link',
  MOBILE_MENU_HELP = 'Mobile Menu Help link',
  MOBILE_MENU_MY_CARE_TEAM = 'Mobile Menu Logged In My Care Team link',
  MOBILE_MENU_DATA_AND_PRIVACY = 'Mobile Menu Logged In Data and Privacy link',
  MOBILE_MENU_HEALTH_INTERESTS = 'Mobile Menu Logged In Health Interests link',
  MOBILE_MENU_OFFERS = 'Mobile Menu Logged In Offers link',

  NO_RESULTS_SUGGESTIONS = 'No Results Screen Suggested Search Links',
  NO_RESULTS_RESET_FILTER = '0 result suggestion - Reset filters',

  PROFILE_BOOKING_BOX_LEARN_MORE_LINK = 'Profile booking box learn more link',
  PROFILE_PRACTICE_INFO_EDIT_PRACTICE_DETAILS_LINK = 'Profile practice information edit practice details link',
  PROFILE_SPECIAL_INTERESTS_LINK = 'Profile special interests link',
  PROFILE_SUPPORTED_GOV_SCHEME_LINK = 'Profile supported gov scheme link',
  PROFILE_VIEW_ON_MAP_LINK = 'Profile view on map link',
  PROMINENT_INSURANCE_DIALOG_CONFIRM = 'Prominent Insurance Dialog Confirm',
  PROMINENT_INSURANCE_FILTER_BUPA = 'Prominent Insurance Filter BUPA',
  PROMINENT_INSURANCE_FILTER_HBF = 'Prominent Insurance Filter HBF',
  PROMINENT_INSURANCE_FILTER_HCF = 'Prominent Insurance Filter HCF',
  PROMINENT_INSURANCE_FILTER_MEDIBANK = 'Prominent Insurance Filter Medibank',
  PROMINENT_INSURANCE_FILTER_NIB = 'Prominent Insurance Filter NIB',
  PROMINENT_INSURANCE_FILTER_MORE = 'Prominent Insurance Filter More',

  SEARCH_BAR_SUGGESTIONS_TAB_ALL = 'Search Bar Suggestions Tab - All',
  SEARCH_BAR_SUGGESTIONS_TAB_SPECIALTIES = 'Search Bar Suggestions Tab - Specialties',
  SEARCH_BAR_SUGGESTIONS_TAB_PRACTICES = 'Search Bar Suggestions Tab - Practices',
  SEARCH_BAR_SUGGESTIONS_TAB_PRACTITIONERS = 'Search Bar Suggestions Tab - Practitioners',
  SEARCH_BAR_SUGGESTIONS_TAB_TOPICS = 'Search Bar Suggestions Tab - Topics',
  SEARCH_BAR_TOP_SPECIALTIES_CHIROPRACTIC = 'Search Bar Top Specialties - Chiropractic',
  SEARCH_BAR_TOP_SPECIALTIES_COVID_VACCINATIONS = 'Search Bar Top Specialties - COVID-19 Vaccinations',
  SEARCH_BAR_TOP_SPECIALTIES_COUNSELLING = 'Search Bar Top Specialties - Counselling',
  SEARCH_BAR_TOP_SPECIALTIES_DENTISTRY = 'Search Bar Top Specialties - Dentistry',
  SEARCH_BAR_TOP_SPECIALTIES_GENERAL_PRACTICE = 'Search Bar Top Specialties - General Practice',
  SEARCH_BAR_TOP_SPECIALTIES_OPTOMETRY = 'Search Bar Top Specialties - Optometry',
  SEARCH_BAR_TOP_SPECIALTIES_PHYSIOTHERAPY = 'Search Bar Top Specialties - Physiotherapy',
  SEARCH_BAR_TOP_SPECIALTIES_PODIATRY = 'Search Bar Top Specialties - Podiatry',
  SEARCH_BAR_TOP_SPECIALTIES_PSYCHOLOGY = 'Search Bar Top Specialties - Psychology',
  SEARCH_BAR_TOP_SPECIALTIES_SKIN_CANCER = 'Search Bar Top Specialties - Skin Cancer',
  SIDEBAR_BROWSE_BY_GENDER = 'Sidebar Browse by gender',
  SIDEBAR_BROWSE_BY_LOCATION = 'Sidebar Browse by Location links',
  SIDEBAR_BROWSE_BY_STATE = 'Sidebar Browse by state dropdown',
}
